export default class CaseUnknownError extends Error {}